import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

type CampusHighlightSliceStateType = {
  highlightLocationCard: boolean;
};

const initialState: CampusHighlightSliceStateType = {
  highlightLocationCard: false,
};

export const campusHighlightSlice = createSlice({
  name: "campusHighlight",
  initialState,
  reducers: {
    setHighlightLocationCard: (state, action: PayloadAction<boolean>) => {
      state.highlightLocationCard = action.payload;
    },
  },
});

export function selectHighlightLocationCard(state: RootState): boolean {
  return state.campusHighlightSlice.highlightLocationCard;
}

export const { setHighlightLocationCard } = campusHighlightSlice.actions;

export default campusHighlightSlice.reducer;
